import mitt from "mitt";

import type { Asset, Err, MasterTemplateFile } from "@/types/types";
import { PlaybackBannerActions, PlaybackBannerEvents } from "@/components/PlaybackControls/usePlaybackController";
import type { MediaLibraryAssetEvent } from "@/enums/mediaLibrary";
import type { MultiviewEvent } from "@/enums/multiview";
import type { EditorEvents } from "@/enums/editor";
import type { ModalActions } from "@/enums/ui";
import { MasterTemplateEvents } from "@/enums/masterTemplate";

type Events = {
    percentLoadEvent: number;
    apolloLoadEvent: number;
    apolloErrorEvent: Err;
    refreshToken: undefined;
    userNotFound: undefined;
    networkError: undefined;
    localDevNetworkError: undefined;

    [ModalActions.AddModalPortal]: string;
    [ModalActions.RemoveModalPortal]: string;

    [PlaybackBannerActions.ReplayBanner]: { namespace: string; id: string };

    [PlaybackBannerActions.Play]: { namespace: string };
    [PlaybackBannerActions.Pause]: { namespace: string };
    [PlaybackBannerActions.Seek]: { namespace: string; time: number };

    [PlaybackBannerEvents.Init]: { namespace: string; id: string };
    [PlaybackBannerEvents.Remove]: { namespace: string; id: string };
    [PlaybackBannerEvents.SetBannerTime]: { namespace: string; id: string; currentTime: number };
    [PlaybackBannerEvents.SetBannerDuration]: { namespace: string; id: string; duration: number };

    [MediaLibraryAssetEvent.AssetRemoved]: Asset;
    [MediaLibraryAssetEvent.AssetsUpdated]: string[];

    [MultiviewEvent.SelectAll]: { instance: string };
    [MultiviewEvent.SelectAllOnPage]: { value: boolean; instance: string };

    [EditorEvents.AddTemplatesToCampaign]: string[];

    [MasterTemplateEvents.UpdateMasterTemplateUploadList]: MasterTemplateFile;
};

const emitter = mitt<Events>();

export default {
    $emit: emitter.emit.bind(emitter),
    $on: emitter.on.bind(emitter),
    $off: emitter.off.bind(emitter)
};
